module.exports = __webpack_public_path__ + "static/track-fb8b7d4a59f59a6242a41e25d9e6f17a.jpg";